var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CaretDown"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CaretDown_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.16107 6.91076C3.48651 6.58533 4.01414 6.58533 4.33958 6.91076L10.0003 12.5715L15.6611 6.91076C15.9865 6.58533 16.5141 6.58533 16.8396 6.91076C17.165 7.2362 17.165 7.76384 16.8396 8.08928L10.5896 14.3393C10.2641 14.6647 9.73651 14.6647 9.41107 14.3393L3.16107 8.08928C2.83563 7.76384 2.83563 7.2362 3.16107 6.91076Z",
    fill: "#353A41"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.009666da062ac57554d684cff6ab6052.svg";
export { ForwardRef as ReactComponent };